export default class TableResponsive {
  init() {
    document.querySelectorAll('table').forEach((table) => {
      if (table.closest('.table-responsive')) return;
      if (table.closest('[data-module="Map"], [data-module="MapLocations"]')) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'table-responsive';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }
}

new TableResponsive().init();
